/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

interface I_DisplayPanelMap {
  bgColor: string;
  position: 'left' | 'right';
}

interface I_DisplayBoxMap {
  bgColor: string;
  position: 'bottomRight' | 'bottomLeft' | 'topLeft' | 'topRight';
  offsetTop: number;
  offsetBottom: number;
  offsetLeft: number;
  offsetRight: number;
}

export const MapWrapper = styled.div``;

export const ActionMapWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 8px;
  padding: 0 8px;
  display: flex;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  pointer-events: none;
  .--left {
    background: rgb(0 0 0 / 0.5);
    border-radius: 4px;
    pointer-events: auto;
  }
  .--right {
    display: flex;
    align-items: center;
    background: rgb(0 0 0 / 0.5);
    border-radius: 4px;
    overflow: hidden;
    pointer-events: auto;
  }
  .action--item {
    cursor: pointer;
    transition: all 0.13s ease-out;
    border: none;
    padding: 0.25rem 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    color: #fff;
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: rgb(0 0 0 / 0.5);
      }
    }
    &.--select {
      width: max-content;
    }
    i {
    }
    &.--select {
      i {
        margin-right: 0px;
        margin-left: 4px;
      }
    }
    &:not(:last-child) {
      border-right: 1px solid rgb(255 255 255 / 0.25);
    }
  }
`;

export const MapPanelWrapper = styled.div<I_DisplayPanelMap>`
  position: absolute;
  width: 30%;
  height: 100%;
  transition: var(--transition-smooth);
  display: flex;
  align-items: center;
  background: ${props => props.bgColor};
  top: 0;
  pointer-events: auto;
  transform: none;
  z-index: 10;
  &.hide {
    pointer-events: none;
    z-index: -1;
    ${props =>
      props.position === 'right'
        ? css`
            transform: translateX(100%);
          `
        : css`
            transform: translateX(-100%);
          `}
  }
  &.wall {
    z-index: 2;
    ${props =>
      props.position === 'right'
        ? css`
            width: calc(30% + 48px);
            ${ActionMapWrapper} {
              justify-content: flex-start;
            }
          `
        : css`
            ${ActionMapWrapper} {
              justify-content: flex-end;
            }
          `}// height: calc(100% - 87px);;;;;;;;;;
  }
  &.basekrpano {
  }
  &.default {
    ${props =>
      props.position === 'right'
        ? css`
            right: 0;
            top: 0;
            height: 100%;
          `
        : css`
            left: 0;
            top: 94px;
            height: calc(100% - 94px);
          `}
  }
  &.custom1 {
    height: calc(100% - 50px);
  }
  ${props =>
    props.position === 'right'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
  .main {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .react-transform-wrapper {
    overflow: visible;
    z-index: 2;
  }
`;

export const MapBoxWrapper = styled.div<I_DisplayBoxMap>`
  position: absolute;
  transition: var(--transition-smooth);
  background: radial-gradient(50% 50% at 50% 50%, #626262 0%, #000000 100%);
  background: ${props => props.bgColor};
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #fff;
  transform: none;
  z-index: 10;
  &.hide {
    opacity: 0;
    z-index: -1;
    pointer-events: none;
    ${props =>
      props.position === 'bottomLeft'
        ? css`
            transform: translateX(-4rem);
          `
        : props.position === 'topLeft'
        ? css`
            transform: translateX(-4rem);
          `
        : props.position === 'topRight'
        ? css`
            transform: translateX(4rem);
          `
        : css`
            transform: translateX(4rem);
          `}
  }
  &.basekrpano {
    /* opacity: 0.5; */
  }
  &.default {
  }
  &.custom1 {
  }
  ${props =>
    props.position === 'bottomLeft'
      ? css`
          bottom: ${props.offsetBottom}px;
          left: ${props.offsetLeft}px;
          right: unset;
          top: unset;
        `
      : props.position === 'topLeft'
      ? css`
          top: ${props.offsetTop}px;
          left: ${props.offsetLeft}px;
          bottom: unset;
          right: unset;
        `
      : props.position === 'topRight'
      ? css`
          top: ${props.offsetTop}px;
          right: ${props.offsetRight}px;
          bottom: unset;
          left: unset;
        `
      : css`
          bottom: ${props.offsetBottom}px;
          right: ${props.offsetRight}px;
          left: unset;
          top: unset;
        `}
`;

export const GoogleMapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const MarkerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  cursor: pointer;
  img {
    width: auto;
    height: auto;
  }
  &.active img {
    box-shadow: 0 0 2px 8px rgb(0 0 0 / 0.1);
    border-radius: 50%;
  }
`;

export const PopupWrapper = styled.div`
  width: 100%;
  height: 80vh;
  position: relative;
  ${ActionMapWrapper} {
    justify-content: center;
    position: fixed;
    top: 1rem;
    left: 0;
  }
`;
